module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_34.f6f03f04.png";